export const chickFilAFridayAttendance = [
  {
    employeeSlug: 'marcus-gunn', passportSlug: 'marcus-g', employeeName: 'Marcus', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 80, attendancePercentage: 88.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'alfred-miller', passportSlug: 'al-m', employeeName: 'Al', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 80, attendancePercentage: 88.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'benjamin-brandt', passportSlug: 'ben-b', employeeName: 'Ben', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 81, attendancePercentage: 90, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'brandon-armstrong', passportSlug: 'brandon-a', employeeName: 'Brandon A.', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 79, attendancePercentage: 87.8, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'jasmine-barnes', passportSlug: 'jasmine-b', employeeName: 'Jasmine', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 71, attendancePercentage: 78.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'bradford-beacham', passportSlug: 'brad-b', employeeName: 'Brad', eligibilityStartDate: '2024-09-13', eligibilityEndDate: '2026-01-23', eligibleEvents: 64, attendedEvents: 51, attendancePercentage: 79.7, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'kevin-louie', passportSlug: 'kevin-l', employeeName: 'Kevin', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 71, attendancePercentage: 78.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'phillip-hetzler', passportSlug: 'phillip-h', employeeName: 'Phillip', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 53, attendancePercentage: 58.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'andrea-fields', employeeName: 'Andrea', eligibilityStartDate: '2026-06-23', eligibilityEndDate: null, eligibleEvents: 9, attendedEvents: 7, attendancePercentage: 77.8, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'brandon-lea', passportSlug: 'brandon-l', employeeName: 'Brandon L.', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 17, attendancePercentage: 18.9, attendanceSource: 'manual-override',
  },
  {
    employeeSlug: 'matt-g', passportSlug: 'matt-g', employeeName: 'Matt', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 90, attendedEvents: 0, attendancePercentage: 0, attendanceSource: 'manual-override',
  },
  {
    employeeSlug: 'arthur-greenberg', employeeName: 'Arthur', eligibilityStartDate: '2026-06-29', eligibilityEndDate: null, eligibleEvents: 8, attendedEvents: 7, attendancePercentage: 87.5, attendanceSource: 'timesheet',
  },
];

export default chickFilAFridayAttendance;
